import { ProductListing as CoreProductListing } from '@df/catalog-ui/listing/product-listing';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { ECustomerGroup } from '../../checkout/module/trade/trade.service';

export class ProductListing<T extends Product = Product<IProductDataV2>> extends CoreProductListing<T> {
    /**
     * Models setter
     */
    override setSourceModels(models: T[]): this {
        super.setSourceModels(models);

        if (this.app.customer?.model.data?.group_id === ECustomerGroup.trade) {
            this.modelsBare = this.modelsBare.filter(i => !(i.data && (<IProductDataV2>i.data).hide_for_trade));
        }

        return this;
    }
}
